export default __webpack_public_path__ + "static/media/grinding_1.3b802e94.png";